// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoAdaptors-VimeoVideoAdapter__video--1BhP2"};